// NOTE: IMPORT OTHER CONSTANTS AND DEPENDENCIES
import Root from "../Layout/Root";
import { createBrowserRouter } from "react-router-dom";
import { FORM_MODES } from "../constants/commonConstants";

// NOTE: IMPORT AUTH PAGES
import SignIn from "../pages/Login/SignIn";
import SignUp from "../pages/Login/SignUp";
import ForgotPassword from "../pages/Login/ForgotPassword";
import VerifyOTP from "../pages/Login/VerifyOTP";
import SetNewPassword from "../pages/Login/SetNewPassword";

// NOTE: IMPORT CLIENT PAGES
import PostJob from "../pages/Client/PostJob";
import FindServicePro from "../pages/Client/FindServicePro";
import ClientTaskerProfile from "../pages/Client/ClientTaskerProfile";
import ClientOrderHistory from "../pages/Client/ClientOrderHistory";
import UserProfile from "../pages/Client/UserProfile";
import RaiseComplaint from "../pages/Client/RaiseComplaint";
import PaymentSucessful from "../pages/Client/PaymentSucessful";
import PaymentUnsucessful from "../pages/Client/PaymentUnsucessful";
import ClientPosts from "../pages/Client/ClientPosts";
import OrderDetails from "../pages/Client/OrderDetails";
import ClientTaskerFeed from "../pages/Client/ClientTaskerFeed";
import RequestRevision from "../pages/Client/RequestRevision";
import Checkout from "../pages/Client/Checkout";

// NOTE: IMPORT TASKER PAGES
import TaskerFeed from "../pages/Tasker/TaskerFeed";
import ExploreJobs from "../pages/Tasker/ExploreJobs";
import TaskerSignUp from "../pages/Tasker/TaskerSignUp";
import TaskerOrderHistory from "../pages/Tasker/TaskerOrderHistory";
import TaskerEditProfile from "../pages/Tasker/TaskerEditProfile";
import TaskerOrderDetails from "../pages/Tasker/TaskerOrderDetails";
import TaskerProfile from "../pages/Tasker/TaskerProfile";
import Wallet from "../pages/Tasker/Wallet";

// NOTE: IMPORT THREAD PAGES
import Thread from "../pages/Thread/Thread";

// NOTE: IMPORT COMMON PAGES
import ErrorPage from "../error/Error";
import AboutUs from "../pages/Client/AboutUs";
import ContactUs from "../pages/Client/ContactUs";
import ServerError from "../error/ServerError";

// NOTE: IMPORT TEST PAGES
import TestReusableComponents from "../pages/TestReusableComponents";
import { UseConfirmationTesting } from "../pages/TestConfirmation";
import TestFormValidation from "../pages/TestFormValidation";
import TestScrolling from "../pages/TestScrolling";

// NOTE: IMPORT HOOKS
import {
  ClientHomePage,
  ProtectedClientRoute,
  ProtectedRedirect,
  ProtectedRoute,
  ProtectedTaskerRoute,
  PublicRoute,
  TaskerHomePage,
} from "../components/protectedAndPublicRoute";
import PrivacyPolicies from "../pages/Client/PrivacyPolicies";
import TermsAndCondition from "../pages/Client/TermsAndCondition"

const router = createBrowserRouter([
  {
    path: "/",
    element: <Root />,
    children: [
      {
        index: true,
        element: <ProtectedRedirect />,
      },


      // Common Public Routes
      {
        path: "",
        element: <PublicRoute />,
        children: [
          {
            path: "about",
            element: <AboutUs />,
          },
          {
            path: "contact",
            element: <ContactUs />,
          },
          {
            path: "tasker-signup",
            element: <TaskerSignUp />,
          },
          {
            path:"privacy-policise",
            element:<PrivacyPolicies/>
          },
          {
            path:"terms-and-condition",
            element: <TermsAndCondition/>
          }
        ],
      },

      // Public Home Pages
      {
        path: "client",
        children: [
          {
            index: true,
            element: <ClientHomePage />, // Public client home
          },
          // Protected Client Routes
          {
            element: <ProtectedClientRoute />,
            children: [
              {
                path: "post-job",
                element: <PostJob mode={FORM_MODES.ADD} />,
              },
              {
                path: "edit-post-job/:jobId",
                element: <PostJob mode={FORM_MODES.EDIT} />,
              },
              {
                path: "view-post-job/:jobId",
                element: <ClientTaskerFeed />,
              },
              {
                path: "find-service-pro",
                element: <FindServicePro />,
              },
              {
                path: "tasker-profile/:taskerId",
                element: <ClientTaskerProfile />,
              },
              {
                path: "order-history",
                element: <ClientOrderHistory />,
              },
              {
                path: "my-posts",
                element: <ClientPosts />,
              },
              {
                path: "profile",
                element: <UserProfile />,
              },
              {
                path: "raise-complaint/:orderId",
                element: <RaiseComplaint />,
              },
              {
                path: "order-details/:orderId",
                element: <OrderDetails />,
              },
              {
                path: "payment-successful",
                element: <PaymentSucessful />,
              },
              {
                path: "payment-unsuccessful",
                element: <PaymentUnsucessful />,
              },
              {
                path: "request-revision/:orderId",
                element: <RequestRevision />,
              },
              {
                path: "checkout/:offerId/:thredId",
                element: <Checkout />,
              },
            ],
          },
        ],
      },

      // Tasker Routes
      {
        path: "service-pro",
        children: [
          {
            index: true,
            element: <TaskerHomePage />, // Public tasker home
          },
          // Protected Tasker Routes
          {
            element: <ProtectedTaskerRoute />,
            children: [
              {
                path: "explore-jobs",
                element: <ExploreJobs />,
              },
              {
                path: "tasker-feed/:jobId",
                element: <TaskerFeed />,
              },
              {
                path: "my-jobs",
                element: <TaskerOrderHistory />,
              },
              {
                path: "my-wallet",
                element: <Wallet />,
              },
              {
                path: "edit-profile",
                element: <TaskerEditProfile />,
              },
              {
                path: "order-details/:orderId",
                element: <TaskerOrderDetails />,
              },
              {
                path: "tasker-profile",
                element: <TaskerProfile />,
              },
            ],
          },
        ],
      },

      // Protected Common Routes
      {
        path: "/chat",
        element: <ProtectedRoute />,
        children: [{ index: true, element: <Thread /> }],
      },
    ],
  },

  // Auth Routes
  {
    path: "/signin",
    element: <SignIn />,
  },
  {
    path: "/signup",
    element: <SignUp />,
  },
  {
    path: "/forgot-password",
    element: <ForgotPassword />,
  },
  {
    path: "/reset-password",
    element: <SetNewPassword />,
  },
  {
    path: "/verify-otp",
    element: <VerifyOTP />,
  },

  // Error Routes
  {
    path: "/server-error",
    element: <ServerError />,
  },

  // Test Routes
  {
    path: "reusable",
    element: <TestReusableComponents />,
  },
  {
    path: "/test-confirmation",
    element: <UseConfirmationTesting />,
  },
  {
    path: "/test-use-form",
    element: <TestFormValidation />,
  },
  {
    path: "/test-scroll",
    element: <TestScrolling />,
  },

  // Error Page
  {
    path: "*",
    element: <ErrorPage />,
  },
]);

export default router;
